export default __webpack_public_path__ + "static/IN-8015_2-8mm_lense_day-887a70b9a50aa3d20c585d2cb63fa5de.webp";